import { type OpenApiSchemaPromo } from '#shared/api/schema';
import { PROMOACTIONS_MODE } from '../constants';
import { type PromoactionModel } from '../types';

export const mapPromoToPromoaction = (promo: OpenApiSchemaPromo): PromoactionModel => {
    const isPercent = promo.discount_value.type === 'PERCENT';

    return {
        id: promo.id,
        title: promo.title,
        kind: 'REGULAR',
        mode: {
            mode: PROMOACTIONS_MODE.automatic,
            promocodeGroupType: 'single',
            promocodeGroupId: '',
        },
        discount: {
            type: isPercent ? 'percent' : 'fixed_amount',
            value_percent: isPercent ? promo.discount_value.value : '',
            value_fixed: isPercent ? '' : promo.discount_value.value,
            minimum_order_amount: '',
            max_discount_amount: '',
        },
        validity: {
            isOneTimeUse: 'false',
            isFirstOrderOnly: 'false',
            maxUsageLimit: 'false',
            isPermanent: !promo.end_date,
            validFrom: promo.start_date,
            validUntil: promo.end_date ?? '',
        },
        applicability: {
            type: 'ALL_PRODUCTS',
            appliedProductListId: '',
            appliedCategoryIds: [],
            appliedCollectionIds: [],
        },
        badge: null,
        autoCollectionId: '',
        autoCollectionTitle: '',
        autoCollectionDescription: '',
        showAutoCollectionInFeed: false,
        showInPdp: 'false',
        meta: {
            type: promo.type === 'LADDER' ? 'ladder' : 'on_products',
            usageCount: promo.usage_count ?? 0,
            deactivated: promo.status === 'INACTIVE',
            status: promo.status === 'ACTIVE' ? 'active' : 'inactive',
            createdAt: promo.created_at,
            updatedAt: promo.created_at,
        },
    };
};
